import React from 'react';
import graphql from 'graphql';
import Helmet from 'react-helmet';

import Intro from '../components/Intro';
import About from '../components/About';
import Gallery from '../components/Gallery';
import OldCatalyst from '../components/OldCatalyst';
import Creators from '../components/Creators';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Cookie from '../components/Cookie';

import gamer from '../img/gamer.svg';

export class LanguagePageTemplate extends React.Component {
  componentDidMount() {
    console.log(document.referrer);
    console.log(location);
  }
  render() {
    return (
      <section style={{position: 'relative'}}>
        <Helmet>
          <title>{this.props.meta.title}</title>
          <meta name="description" content={this.props.meta.description} />
        </Helmet>

        <Cookie />

        <Navbar
          apply={this.props.intro.content.apply}
          googleLogin={this.props.intro.content.googleLogin}
        />
        <Intro
          language={this.props.intro.language}
          intro={this.props.intro.content.title}
          apply={this.props.intro.content.apply}
          googleLogin={this.props.intro.content.googleLogin}
        />
        <About
          title={this.props.about.title}
          description={this.props.about.description}
          image={this.props.about.image}
        />
        <Gallery
          title={this.props.gallery.title}
          description={this.props.gallery.description}
          galleries={this.props.gallery.list}
        />
        <OldCatalyst
          title={this.props.oldCatalyst.title}
          description={this.props.oldCatalyst.description}
          image={this.props.oldCatalyst.image}
        />
        <Creators
          title={this.props.creators.title}
          testimonials={this.props.creators.testimonials}
        />
        <Footer
          support={{label: this.props.footer.content.support.label, url: this.props.footer.content.support.url}}
          tos={{label: this.props.footer.content.tos.label, url: this.props.footer.content.tos.url}}
          privacy={{label: this.props.footer.content.privacy.label, url: this.props.footer.content.privacy.url}}
          community={{label: this.props.footer.content.community.label, url: this.props.footer.content.community.url}}
          bbtvCopyright={this.props.footer.content.bbtvCopyright}
          language={this.props.footer.language}
        />
      </section>
    );
  }
};

export default ({ data }) => {
  const currentPath = data.markdownRemark.frontmatter.path;
  const allLanguages = data.allMarkdownRemark.edges.map(post => {
    return {
      language: post.node.frontmatter.language,
      path: post.node.frontmatter.path
    }
  });

  return data.allMarkdownRemark.edges
   .filter(post => post.node.frontmatter.path === currentPath)
   .map(({ node: post }, i) => {
     const language = {
       allLanguages: allLanguages,
       selected: post.frontmatter.language
     }
     return (
       <LanguagePageTemplate
         key={i}
         meta={post.frontmatter.meta}
         intro={{content: post.frontmatter.intro, language: language}}
         about={post.frontmatter.about}
         gallery={post.frontmatter.gallery}
         oldCatalyst={post.frontmatter.oldCatalyst}
         creators={post.frontmatter.creators}
         footer={{content: post.frontmatter.footer, language: language}}
       />
     )
   })
};

export const pageQuery = graphql`
  query IndexQuery($path: String!) {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          frontmatter {
            path
            language
            path
            date(formatString: "MMMM DD, YYYY")
            meta {
              title
              description
            }
            intro {
              title
              googleLogin {
                label
                url
                shortened
              }
              apply {
                label
                labelLink
                url
              }
            }
            about {
              title
              description
              image
            }
            gallery {
              title
              description
              list {
                text
                bg
                img
                title
                description
              }
            }
            oldCatalyst {
              title
              description
              image
            }
            creators {
              title
              testimonials {
                author
                avatar
                quote
              }
            }
            footer {
              support {
                label
                url
              }
              tos {
                label
                url
              }
              privacy {
                label
                url
              }
              community {
                label
                url
              }
              bbtvCopyright
            }
          }
        }
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        path
        language
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/language-page.js